import CenterFormLayout from 'components/Layout/centerFormLayout'
import React from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CreateFindings from './createDiagnosticFindings';

const CreateDiagnosticFindings = () => {
  const navigate  = useNavigate();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch({
      type: 'SET_SINGLE_REPORT',
      payload: null
    });
    return navigate(-1);
  };

  

  return (
    <div>
      <CenterFormLayout backTheme="tertiary"
        backSize="sm"
        closeTheme="tertiary"
        closeSize="sm"
        onBackClick={handleClose}
        title="Create Diagnostic Findings"
        onClose={handleClose}
        >
         <CreateFindings />
      </CenterFormLayout>
    </div>
  )
}

export default CreateDiagnosticFindings